import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TockLogo from '../../svg/logos/tock-logo.svg';
import { getTranslation } from '../../providers/TranslationProvider';

import './TockBadge.scss';

const TockBadge = ({ large }) => {
  const badgeLabel = getTranslation({
    translationKey: 'book_on_tock',
    fallback: 'Book on Tock',
  });
  const bookOnText = getTranslation({
    translationKey: 'book_on',
    fallback: 'Book on',
  });

  return (
    <div className={classNames('TockBadge', { TockBadge__large: large })} role="img" aria-label={badgeLabel}>
      <span>{bookOnText}</span>
      <TockLogo data-testid="tock-logo" className="TockBadge__logo" aria-hidden="true" focusable="false" />
    </div>
  );
};

TockBadge.displayName = 'TockBadge';

TockBadge.propTypes = {
  large: PropTypes.bool,
};

TockBadge.defaultProps = {
  large: false,
};

export default TockBadge;
